import { httpPost, httpGet } from "@/utils/request";

export const getUserList = (params) => httpGet("/api/user", params);

export const createUser = (data) => httpPost("/api/user/store", data);
export const editMyPassword = (data) => httpPost("/api/user/editMyPassword", data);

export const delUser = (id) => httpPost(`/api/user/remove/${id}`);
